import type { CSSProperties } from "react";
import { AgGridReact, type AgGridReactProps } from "ag-grid-react";
import { useIsDarkMode } from "@/features/theme/theme";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";

/**
 * Wraps AG Grid Community (ADR-005) behind a reduced, typed API so the dependency
 * stays isolated and replaceable. The AG Grid theme CSS import is the sole exception
 * to ADR-004 (no project `.css`), as it ships with the third-party library.
 */
export function DataTable<TData>(props: AgGridReactProps<TData>) {
  const isDark = useIsDarkMode();
  return (
    <div
      className={isDark ? "ag-theme-quartz-dark" : "ag-theme-quartz"}
      style={
        {
          width: "100%",
          height: "100%",
          // Square corners, homogeneous with the (non-rounded) ENGIE design system.
          "--ag-border-radius": "0px",
          "--ag-wrapper-border-radius": "0px",
        } as CSSProperties
      }
    >
      <AgGridReact<TData> animateRows domLayout="autoHeight" {...props} />
    </div>
  );
}
